import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{
  padding: number;
  contentTopPadding: number;
  minHeight: number;
  hover: boolean;
}>()((theme: Theme, { padding, minHeight, contentTopPadding, hover }) => ({
  root: {
    padding: 0,

    '&.MuiAccordion-root:before': {
      backgroundColor: theme.palette.divider,
    },
    '&.MuiAccordion-root.Mui-expanded:before': {
      opacity: 1,
    },

    '&.MuiPaper-root.MuiPaper-elevation': {
      margin: theme.spacing(0),
    },

    '&.MuiPaper-root.MuiPaper-elevation.MuiAccordion-root': {
      borderRadius: theme.spacing(0),
      backgroundImage: 'none',
      boxShadow: 'none',
    },

    '& .MuiButtonBase-root.MuiAccordionSummary-root.Mui-expanded': {
      backgroundColor: hover ? theme.palette.modal.active : '#222327',
    },

    '& .MuiButtonBase-root.MuiAccordionSummary-root': {
      backgroundColor: hover ? theme.palette.modal.paper : '#222327',
      padding: theme.spacing(padding),

      alignItems: 'flex-start',

      '&:hover': {
        backgroundColor: hover ? theme.palette.modal.active : '#222327',
      },
    },

    '& .MuiCollapse-root': {
      backgroundColor: theme.palette.modal.paper,
    },

    '& .MuiAccordionDetails-root': {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(contentTopPadding),
    },

    '& .MuiAccordionSummary-content': {
      margin: 0,

      '&.Mui-expanded': {
        margin: 0,
      },
    },
  },

  accordionSummary: {
    display: 'flex',
    flexDirection: 'column',
  },

  accordionTitle: {
    textTransform: 'uppercase',
    paddingBottom: theme.spacing(0.625),

    '&.MuiTypography-root': {
      letterSpacing: '0.15em',
      fontWeight: 'bold',
      fontSize: theme.spacing(1.75),
    },
  },

  descriptionContainer: {
    minHeight: theme.spacing(minHeight ?? 'auto'),
  },
}));
